import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizacionesService } from '@app/_services/organizaciones.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService } from '@app/_services';
import { PublicacionesService } from '@app/_services/publicaciones.service';
import { IdiomasService } from '@app/_services/idiomas.service';
import { Ente } from '@app/_models/ente';
import { Categoria } from '@app/_models/categoria';
import { Idioma } from '@app/_models/idioma';
import { Noticia, NoticiaTraduccion } from '@app/_models/noticia';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { x } from '@progress/kendo-svg-icons';
import { AlertService, DepartamentosService } from '@app/_services';
import { stringify } from '@angular/compiler/src/util';
import { Recinto } from '@app/_models/recinto';
import { RecintosService } from '@app/_services/recintos.service';
import { RestauranteService } from '@app/_services/restaurante.service';
import { ComidaTipo } from '@app/_models/restaurante';

@Component({
  selector: 'app-comidastipo',
  templateUrl: './comidastipo.component.html',
})
export class ComidastipoComponent implements OnInit {
  listaEntesAdministrados: Ente[] = [];
  selectedOrg: Ente;
  listaComidas: ComidaTipo[] = [];
  public seleccionados: number[] = [];
  idOrg:string;
  idRecinto:string;

  lang;
  private translate: TranslateService;
  modalReference: NgbModalRef;
  modalReferenceloading: NgbModalRef;

  constructor(
    private restauranteService: RestauranteService,
    private idiomaService: IdiomasService,
    private organizacionService: OrganizacionesService,
    private menuService: MenuService,
    public router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    translate: TranslateService,
    private translateService: TranslateService,
    private modalService: NgbModal
  ) {
    this.translate = translate;
    this.menuService.titulo = this.translate.instant('restaurante.cabecera');

  }

  ngOnInit(): void {
    this.lang = this.translateService.getDefaultLang();
    this.idOrg = this.route.snapshot.params['idorg'];
    this.idRecinto = this.route.snapshot.params['idrestaurante'];
    this.restauranteService.GetComidasFromRestaurante(this.idRecinto).subscribe((resultEntes) => {
      this.listaEntesAdministrados = resultEntes.data;
      if (this.listaEntesAdministrados.length > 0) {
        this.selectedOrg = this.listaEntesAdministrados[0];
        this.restauranteService
          .GetComidasFromRestaurante(this.idRecinto)
          .subscribe((resultRecintos) => {
            console.log(resultRecintos.data);
            this.listaComidas = resultRecintos.data;
          });
      }
    });
  }

  loadRecintos(value, dropDownControl: DropDownListComponent) {
    console.log('Cargando recintos de :' + value.id);
    this.restauranteService
      .getRestaurantesFromEnte(this.selectedOrg.id)
      .subscribe((result) => {
        console.log(result);
        this.listaComidas = result.data;
      });
  }

  onClickNuevo() {
      this.router.navigate(['comidas-crear', {idorg:this.idOrg, idrestaurante:this.idRecinto }]);

  }

  onClickEliminar(content) {
    console.log('Eliminando...');
    if (this.seleccionados.length > 0) {
      this.modalReference = this.modalService.open(content, {
        backdrop: 'static',
        size: 'lg',
        keyboard: false,
        centered: true,
      });
    }
  }

  onClickEditar() {
    this.router.navigate([
      'comidas-editar',
      {idorg:this.idOrg, idrestaurante:this.idRecinto, idcomida: this.seleccionados[0] },
    ]);
  }

  cellClick() {
    this.router.navigate([
      'comidas-editar',
      {idorg:this.idOrg, idrestaurante:this.idRecinto, idcomida: this.seleccionados[0] },
    ]);
  }

  eliminarRegistro(contentloading) {
    console.log('Eliminar registro');
    this.restauranteService
      .deleteRestaurantes({ codigos: this.seleccionados })
      .subscribe((data) => {
        if (data.error == false) {
          this.restauranteService
            .getRestaurantesFromEnte(this.selectedOrg.id)
            .subscribe((result) => {
              this.listaComidas = result.data;
            });
        }
        this.modalReferenceloading.close();
      });
    this.modalReference.close();
    this.modalReferenceloading = this.modalService.open(contentloading, {
      backdrop: 'static',
      size: 'sm',
      keyboard: false,
      centered: true,
    });
    this.seleccionados = [];
  }
}
